import React, { } from "react";
import { useAppContext } from "../utils/context/app-context";
import {
	ContentContainer,
	TitleHeader,
} from "../components/UiComponents";
import {
	CourseHeader,
	CourseWrapper
} from "../components/CourseComponents";
import useDocumentTitle from "../components/useDocumentTitle";

const StudentFormsAccessPage = () => {
	const { state, api } = useAppContext();
	useDocumentTitle("Student Forms Access");

	if (!state.current_date_id) {
		return null
	}
	const course = api.getCurrentCourse()
	const date = api.getCurrentDate()
	const qrInfo = date.qr_info
	const qrImage = qrInfo ? qrInfo.qrcode : null
	const formsAreaDomain = qrInfo ? qrInfo.domain : null
	const registrationUrl = qrInfo ? qrInfo.url : null

	return (
		<div className="student-access-page">
			<CourseHeader />
			<ContentContainer classes="mb-4">
				<CourseWrapper>
					<TitleHeader title="Participant Forms Access" />
					<div className="student-forms-access">
						<div className="student-forms-access__left">
							<div className="student-forms-access__subtitle">
								<h3>Scan this QR Code or <a href={registrationUrl} target="_blank" rel="noreferrer">Click HERE</a></h3>
							</div>
							<div className="student-forms-access__qr-container">
								<img src={qrImage} alt="QR Code" />
							</div>
						</div>
						<div className="student-forms-access__center">
							<h3 className="student-forms-access__or">OR</h3>
							<div className="student-forms-access__separator"></div>
						</div>
						<div className="student-forms-access__right">
							<div className="student-forms-access__subtitle">
								<h3>Go to this URL below</h3>
							</div>
							<div className="student-forms-access__details">
								<AccessField
									label="1. Enter in Browser"
									content={formsAreaDomain}
								/>
								<AccessField
									label="2. Enter Course Access Code"
									content={course.course_access_code}
								/>
								<AccessField
									label="3. Enter Access ID (Day ID)"
									content={date.id}
								/>
							</div>
						</div>
					</div>
				</CourseWrapper>
			</ContentContainer>
		</div>
	);
}

const AccessField = ({ label, content }) => {
	return (
		<div className="student-forms-access__field">
			<div className="student-forms-access__field-label">
				{label}
			</div>
			<div className="student-forms-access__field-content">
				{content}
			</div>
		</div>
	)
}

export default StudentFormsAccessPage;
